// Import a community sample into the local library so it plays via
// `s("<name>")` like every other sample.
//
// All of the heavy lifting — fetch, decode, register, hash, IDB write
// — lives in `importCloudBlobToLocal`. This file only adapts a
// `CommunitySample` row into the shared input shape and labels the
// resulting Sample's origin so provenance views can tell the source
// apart from a "pulled my own cloud sample" import.

import { importCloudBlobToLocal } from './importCloudBlob';
import type { SampleStorage } from '../samples/storage/idb';
import type { Sample } from '../samples/types';
import type { CommunitySample } from './api';

export type ImportResult = {
  /** The Sample row written to IDB. Its `name` is what `s(…)` expects. */
  sample: Sample;
};

export async function importCommunitySample(
  cloud: CommunitySample,
  ctx: AudioContext,
  storage: SampleStorage,
): Promise<ImportResult> {
  return importCloudBlobToLocal({
    source: {
      id: cloud.id,
      name: cloud.name,
      durationMs: cloud.durationMs,
      tags: cloud.tags,
      license: cloud.license,
      r2Key: cloud.r2Key,
    },
    filenameOrigin: `community:${cloud.id}`,
    ctx,
    storage,
  });
}
